import Layout from '@/layout'

const route = {
  path: '/cert',
  component: Layout,
  redirect: '/cert/index',
  alwaysShow: true, // will always show the root menu
  name: 'cert',
  meta: {
    title: 'cert',
    icon: 'el-icon-document',
    roles: [
      'larke-admin.cert.index'
    ]
  },
  sort: 110070,
  children: [
    // 扩展管理
    {
      path: '/cert/index',
      component: () => import('@/views/cert/index'),
      name: 'certIndex',
      meta: {
        title: 'certIndex',
        icon: 'el-icon-tickets',
        roles: [
          'larke-admin.cert.index'
        ]
      }
    }
  ]
}

export default route
